const KEY = "shc_utm";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

// First-touch within the session: the first ad link that brought them here wins.
export function captureUtm() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const p = new URLSearchParams(window.location.search);
    const got = {};
    for (const k of UTM_KEYS) {
      const v = p.get(k);
      if (v) got[k] = v.slice(0, 80);
    }
    if (Object.keys(got).length) {
      got.landing_page = window.location.pathname;
      got.captured_at = new Date().toISOString();
      sessionStorage.setItem(KEY, JSON.stringify(got));
    }
  } catch { /* storage unavailable */ }
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}
